module.exports = __webpack_public_path__ + "media/images/icon/strength-a2818368fd9503934b2bda470c22ac75.png";